import ztComponent from './ztListItem.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
